import { render } from "./ProfileIcon.vue?vue&type=template&id=3a427b88&scoped=true"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"

import "./ProfileIcon.vue?vue&type=style&index=0&id=3a427b88&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a427b88"]])

export default __exports__